module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "prologue"
    }
  }, [_c('p', [_c('img', {
    staticStyle: {
      "width": "550px",
      "height": "550px"
    },
    attrs: {
      "alt": "",
      "src": "media/image4.jpeg"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "text-indent": "280px",
      "font-size": "40pt",
      "font-family": "calibri",
      "text-align": "center"
    }
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri",
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("Seeing the world upside down and from down under")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri",
      "text-indent": "0px"
    }
  }, [_vm._v("This map by the French cartographer G de l’ Isle, published by G and H de Leth in Amsterdam in or after 1714, shows Tasman’s 1642 and later mapping of northern, western and southern Australia, and his discoveries of Tasmania, New Zealand and Fiji. His travels contributed to a new perception of the world we live in. The maps show that by the start of the 18th century, Europe was starting to think globally.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri",
      "text-indent": "0px"
    }
  }, [_c('em', [_vm._v("Source: Amsterdam Museum, hdl.handle.net/11259/collection.71646, commons.wikimedia.org")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab9d586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 81
// module chunks = 0